export function PageContent(props: { children: React.ReactNode }) {
  return <div className="p-8">{props.children}</div>;
}
